module.exports = __webpack_public_path__ + "static/media/LGCP01.1099fedc.jpg";